// Adverts shown in the Marketplace "Suggested" feed. Add entries here later:
// { id: "ad_1", sponsor: "Brand", title: "Headline", image: "https://…", url: "https://…", cta: "Shop now" }
export const ADS = [];
